(() => {
  if (window.SimpsonHubReferrals) return;
  class HubReferrals {
    constructor(hub) {
      this.hub = hub;
      this.widget = hub.querySelector('[data-hub-referrals-widget]');
      this.loading = hub.querySelector('[data-hub-referrals-loading]');
      this.error = hub.querySelector('[data-hub-referrals-error]');
      if (this.widget) {
        this.observer = new MutationObserver(() => this.check());
        this.observer.observe(this.widget, { childList: true, subtree: true });
        this.check();
      }
    }
    check() {
      if (!this.widget?.querySelector('input,button,a')) return false;
      clearTimeout(this.timer);
      if (this.loading) this.loading.hidden = true;
      if (this.error) this.error.hidden = true;
      return true;
    }
    activate(view) {
      if (view !== 'loyalty-referrals' || !this.widget || this.check()) return;
      if (this.loading) this.loading.hidden = false;
      if (this.error) this.error.hidden = true;
      // The loyalty sender component avoids the standalone widget's retained
      // recipient-claim session and uses the signed-in member's native tools.
      if (!document.querySelector('script[src*="/loyalty/js/init-onsite"]')) {
        const script = document.createElement('script');
        script.src = 'https://cdn-static.okendo.io/loyalty/js/init-onsite.js';
        script.defer = true; document.head.append(script);
      }
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.check()) return;
        if (this.loading) this.loading.hidden = true;
        if (this.error) this.error.hidden = false;
      }, 20000);
    }
    destroy() { clearTimeout(this.timer); this.observer?.disconnect(); }
  }
  window.SimpsonHubReferrals = HubReferrals;
})();
